import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/contractors";

const { actions, types } = createActions({
  addContractor: ["contractor", "onSuccess", "onFailure"],
  updateContractor: ["id", "contractor", "onSuccess", "onFailure"],
  setContractorLoading: ["loading"],
  fetchContractorRequest: ["page", "perPage", "onFailure"],
  setInitialContractorFetchIsDone: [],
  setContractorTotalItems: ["totalItems"],
  setContractorPerPage: ["perPage"],
  setContractorPage: ["page"],
  addContractors: ["contractors"],
  setContractorQs: ["qs"],

  fetchContractorLocationRequest: ["onFailure"],
  addContractorLocations: ["locations"],

  fetchCompaniesLocationRequest: ["onFailure"],
  addContractorCompanies: ["companies"],

  fetchContractorJobsRequest: ["onFailure"],
  addContractorJobs: ["jobs"],

  fetchContractorTypeCodesRequest: ["onFailure"],
  addContractorTypeCodes: ["typeCodes"],
});

const reducer = createReducer(initialState, {
  [types.ADD_CONTRACTORS]: (state, { payload }) => ({
    ...state,
    contractors: [...payload.contractors],
  }),
  [types.ADD_CONTRACTOR_LOCATIONS]: (state, { payload }) => ({
    ...state,
    locations: [...payload.locations],
  }),
  [types.ADD_CONTRACTOR_COMPANIES]: (state, { payload }) => ({
    ...state,
    companies: [...payload.companies],
  }),
  [types.ADD_CONTRACTOR_JOBS]: (state, { payload }) => ({
    ...state,
    jobs: [...payload.jobs],
  }),
  [types.ADD_CONTRACTOR_TYPE_CODES]: (state, { payload }) => ({
    ...state,
    typeCodes: [...payload.typeCodes],
  }),
  [types.SET_CONTRACTOR_LOADING]: (state, { payload }) => ({
    ...state,
    loading: payload.loading,
  }),

  [types.SET_INITIAL_CONTRACTOR_FETCH_IS_DONE]: (state) => ({
    ...state,
    initialFetchIsDone: true,
  }),
  [types.SET_CONTRACTOR_TOTAL_ITEMS]: (state, { payload }) => ({
    ...state,
    totalItems: payload.totalItems,
  }),

  [types.SET_CONTRACTOR_PAGE]: (state, { payload }) => ({
    ...state,
    page: payload.page,
  }),
  [types.SET_CONTRACTOR_PER_PAGE]: (state, { payload }) => ({
    ...state,
    perPage: payload.perPage,
  }),

  [types.SET_CONTRACTOR_QS]: (state, { payload }) => ({
    ...state,
    qs: payload.qs,
    page: 0,
  }),
});

export { reducer as default, types, actions };
